
import React, {useState} from 'react';
import { Link, useNavigate} from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import api from '../../services/api';

import './style.css';

import logoImg from '../../assets/img/logo.png';


export default function Register(){
	//Criação de estados
	const [name, setName] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword ] = useState('');
	const [whatsapp, setWhatsApp ] = useState('');
    const [country, setCounty] = useState('');
    const [address, setAddress] = useState('');
	const [role, setRole] = useState("")

	//name, email, password, photo, contact, country, address, role

	const navigate = useNavigate();

	async function handleRegister(error){
		error.preventDefault();

		const data = {
			name,
			birthDate,
			email,
			password,
			whatsapp,
			country,
			address,
			role,
		};

		try {
			await api.post('user\register', data);
			alert("Registo efectuado com sucesso!")				
			
			navigate('/profile');

		} catch (err) {
			alert('Erro ao efectuar registo, tente novamente');            
		}

	}
	
	return (
		<div className="new-register-container">
			<div className="content">
				<section>
					<img src={logoImg} alt = "Dodo" />
					<h1>Registro de usuario</h1>
					<p>
						Descreva o novo caso detalhadamente para encontra
						um heroi para resolver isso
					</p>

					<Link className="back-link" to="/profile">
						<FiArrowLeft size={16} color="#E02041"/>
						Voltar para home
					</Link>
				</section>

				<form  onSubmit={handleRegister}>
					<input 
						placeholder="Nome completo"
						type="text"
						value={name}
						onChange={ error => setName(error.target.value)}
					/>

					<input 
						placeholder="Email"
						type="email"
						value={email}
						onChange={ error => setEmail(error.target.value)}
					/>

					<input 
						placeholder="Senha"
						type="password"
						value={password}
						onChange={ error => setPassword(error.target.value)}
					/>

					<input 
						placeholder="Whatsapp"
						type="phone"
						value={whatsapp}
						onChange={ error => setWhatsApp(error.target.value)}
					/>

					<input 
						placeholder="Data Nascimento"
						type="date"
						value={birthDate}
						onChange={ error => setBirthDate(error.target.value)}
					/>

					<input 
						placeholder="País"
						value={country}
						onChange={ error => setCounty(error.target.value)}
					/>

					<input 
						placeholder="Endereço"
						value={address}
						onChange={ error => setAddress(error.target.value)}
					/>

					<input 
						placeholder="Role"
						value={role}
						onChange={ error => setAddress(error.target.value)}
					/>
							
					<button className="button" type="submit">Cadastrar</button>
				</form>
			</div>
		</div>
	);
}

